export const AssociationInputType = 'ASSOCIATION';
export const CtaInputType = 'CTA';
export const DateStaticOrDynamicInputType = 'DATE_STATIC_OR_DYNAMIC';
export const DefaultInputType = 'DEFAULT';
export const EmailLinkInputType = 'EMAIL_LINK';
export const EmailSubscriptionInputType = 'EMAIL_SUBSCRIPTION';
export const MultiCurrencyCurrencyCode = 'CURRENCY';
export const RangeInputType = 'RANGE';
export const PropertyInputType = 'PROPERTY';
export const RollingBoundedInequalityInputType = 'ROLLING_BOUNDED_INEQUALITY';
export const RollingBoundedInequalityWithOrWithoutYearInputType = 'ROLLING_BOUNDED_INEQUALITY_WITH_OR_WITHOUT_YEAR';
export const RollingDateInputType = 'ROLLING_DATE';
export const RollingInequalityInputType = 'ROLLING_INEQUALITY';
export const RollingPropertyUpdatedInputType = 'ROLLING_PROPERTY_UPDATED';
export const RollingDatePointInputType = 'ROLLING_DATE_POINT';
export const RollingWithUnitInputType = 'ROLLING_WITH_UNIT';
export const NoInputType = 'NONE';
export const UrlInputType = 'URL';